import component from '@/components/select/date-picker/date-picker'
export default {
  mapKey: 'date',
  label: 'select.datePicker',
  formItem: {
    component
  }
}
